<template>
  <q-page padding>
    <div
      style="align-items: center"
      class="row col-12 justify-between align-center"
    >
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Consulta Status
        <q-icon
          style="cursor: pointer"
          name="info_outlined"
          @click="activeSlide = !activeSlide"
        />
      </p>
      <span
        style="cursor: pointer"
        class="row justify-end q-mt-md q-mb-md"
        @click="backPage"
      >
        <div @click="backPage" class="row align-center">
          <q-icon
            label="voltar"
            class="q-mr-sm"
            color="grey"
            size="sm"
            name="west"
          />
          <span style="color: #8a8a8a; font-size: 20px">Voltar</span>
        </div>
      </span>
    </div>

    <div class="cards-topo">
      <section style="background-color: #5b9ed6">
        <span
          style="font-size: 24px"
          class="q-mb-md text-white text-weight-bolder"
          >{{ dadosTopo.primeiro }}</span
        >
        <span class="sub text-white">Associação Produtos x Pessoas</span>
      </section>
      <section style="background-color: #85d546">
        <span
          style="font-size: 24px"
          class="q-mb-md text-white text-weight-bolder"
          >{{ dadosTopo.segundo }}</span
        >
        <span class="sub text-white">Antes do Prazo Mínimo</span>
      </section>
      <section style="background-color: #eebf00">
        <span
          style="font-size: 24px"
          class="q-mb-md text-white text-weight-bolder"
          >{{ dadosTopo.terceiro }}</span
        >
        <span class="sub text-white">Associações Sem Movimento</span>
      </section>
      <section style="background-color: #dd2153">
        <span
          style="font-size: 24px"
          class="q-mb-md text-white text-weight-bolder"
          >{{ dadosTopo.quarto }}</span
        >
        <span class="sub text-white">Prazo Máximo Excedido</span>
      </section>
    </div>

    <span style="font-size: 16px; color: #21324a"
      >Selecione a unidade e o colaborador para a retirada</span
    >
    <div
      class="row col-12 text-weight-bold text-brand-5 q-mt-md q-gutter-sm container-inputs q-mb-md"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="texto-titulo-input q-ml-md">Unidade</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
        ></lista-unidades-select>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-6">
        <div class="texto-titulo-input q-ml-md">.</div>
        <SelecaoSolicitante
          class="input-new-design"
          @emitirFuncionario="receberFuncionario"
        />
      </div>
    </div>

    <span v-if="userData.nome" style="font-size: 16px; color: #21324a"
      >Informe o status ou o nome do grupo para filtrar</span
    >

    <div
      v-if="userData.nome"
      class="row col-12 text-weight-bold text-brand-5 q-mt-md q-gutter-sm container-inputs"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div style="color: #21324a" class="texto-titulo-input q-ml-md">
          Status
        </div>
        <q-select
          label="Selecione o Status"
          :options="tipos"
          v-model="status"
          dense
          outlined
        />
      </div>

      <div class="col-md-4 col-sm-6 col-xs-6">
        <div style="color: #21324a" class="texto-titulo-input q-ml-md">
          Grupo Produto
        </div>
        <q-input
          label="Filtre pelo Grupo de Produto"
          dense
          outlined
          v-model="grupo"
        />
      </div>
    </div>

    <section v-if="userData.nome" class="row list-container">
      <div v-for="(grupo, index) in rows" :key="index" class="grupo-container">
        <span style="width: 25%; display: flex; align-items: center">
          <q-img
            spinner-color="white"
            height="83px"
            width="87px"
            src="../../../assets/imageDefoult.jpg"
            fit="contain"
            no-native-menu
          />
        </span>

        <span
          class="column"
          style="width: 50%; align-items: center; text-align: center"
        >
          <div
            class="q-mt-sm"
            style="font-size: 10px; font-weight: bold; color: #8a8a8a"
          >
            GRUPO PRODUTO
          </div>
          <div
            style="
              justify-content: center;
              height: 70%;
              justify-content: center;
              align-items: center;
              color: #21324a;
              font-size: 16px;
            "
            class="row"
          >
            {{ grupo.grupo_nome }}
          </div>
        </span>
        <span
          class="column"
          style="width: 25%; align-items: center; justify-content: center"
        >
          <div
            style="
              font-size: 10px;
              font-weight: bold;
              color: #8a8a8a;
              margin-bottom: -10px;
            "
          >
            STATUS
          </div>
          <div
            class="q-mt-sm"
            style="font-size: 16px; font-weight: bold; text-align: center"
            :style="{
              color: getTitleColor(grupo?.Status),
            }"
          >
            {{ grupo?.Status?.toUpperCase() }}
          </div>

          <div
            v-if="grupo.Status == 'ATENÇÃO' || grupo.Status == 'ATRASADO'"
            style="font-size: 10px; font-weight: bold; color: #8a8a8a"
          >
            RETIRADA MAXIMA
          </div>
          <div
            style="font-size: 10px; font-weight: bold; color: #8a8a8a"
            v-else
          >
            PROXIMA RETIRADA
          </div>
          <div
            :style="{
              color: getTitleColor(grupo?.Status),
            }"
            v-if="grupo?.prazo_maximo"
            style="font-size: 10px; font-weight: bold"
          >
            {{
              grupo?.prazo_maximo?.split(" ")[0].split("-").reverse().join("/")
            }}
          </div>
          <div
            :style="{
              color: getTitleColor(grupo?.Status),
            }"
            v-else
            style="font-size: 10px; font-weight: bold"
          >
            Sem prazo
          </div>
          <div
            :style="{
              color: getTitleColor(grupo?.Status),
            }"
            style="font-size: 10px; font-weight: bold"
          >
            <span v-if="Math.sign(grupo['Dias para vencer máximo']) == 1"
              >Vence em {{ grupo["Dias para vencer máximo"] }} dias!</span
            >
            <span v-if="Math.sign(grupo['Dias para vencer máximo']) == -1"
              >Vencido a
              {{ Math.abs(grupo["Dias para vencer máximo"]) }} dias!</span
            >
          </div>
        </span>
      </div>
    </section>

    <div v-if="rows.length > 0" class="row justify-start q-mt-md">
      <q-pagination
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <SlideInformations :infos="infos" :activeSlide="activeSlide" />
  </q-page>
</template>

<script>
import { useRouter } from "vue-router";
import { onMounted, watch, ref, computed } from "vue";
import { useQuasar } from "quasar";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import SlideInformations from "../components/SlideInformations.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
export default {
  components: {
    ListaUnidadesSelect,
    SlideInformations,
    SelecaoSolicitante,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();
    const activeSlide = ref(false);
    const dadosTopo = ref({
      primeiro: 0,
      segundo: 0,
      terceiro: 0,
      quarto: 0,
    });
    const rows = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    const userData = ref({
      nome: "",
      ghe: "",
      matricula: "",
      unidade: "",
      centro: "",
      cargo: "",
    });
    const time = ref(null);
    const status = ref("");
    const grupo = ref("");
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    const unidadeList = ref([]);

    const getDados = async () => {
      quasar.loading.show();

      if (userData.value.matricula == "") {
        quasar.loading.hide();
        return;
      }
      if (
        store.state.autenticacao.cliente.includes("staging-vale") ||
        store.state.autenticacao.cliente.includes("vale-epiexpress")
      ) {
        return;
      }
      try {
        let response = await store.dispatch("ind/getStatusTroca", {
          vendor_id: unidade.value.id,
          per_page: 11,
          page: pagination.value.page,
          product_group: grupo.value,
          status: status.value.value,
          user: userData.value.matricula,
        });
        if (response.data.result.data.length == 0) {
          quasar.loading.hide();
          quasar.notify({
            message:
              "Usuário selecionado não possui regras na unidade selecionada",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        rows.value = response.data.result.data;

        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.result.total;
        pagination.value.page = response.data.result.current_page;
        quasar.loading.hide();
        getDadosTopo();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message:
            "Usuário selecionado não possui regras na unidade selecionada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getDadosTopo = async () => {
      if (
        store.state.autenticacao.cliente.includes("staging-vale") ||
        store.state.autenticacao.cliente.includes("vale-epiexpress")
      ) {
        return;
      }
      try {
        let response = await store.dispatch("ind/getStatusTrocaTopo", {
          vendor_id: unidade.value.id,
          pessoa: userData.value.nome,
        });

        dadosTopo.value.primeiro = response.data.quantidade_de_associacoes;
        dadosTopo.value.segundo = response.data.numero_itens_dentro_prazo;
        dadosTopo.value.terceiro = response.data.associacoes_sem_nunca_ter_pego;
        dadosTopo.value.quarto = response.data.numero_itens_fora_prazo;
        quasar.loading.hide();
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const backPage = async () => {
      router.push({ name: "spf-inicial" });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    const receberFuncionario = (value) => {
      userData.value.nome = value?.name;
      userData.value.ghe = value?.function;
      userData.value.centro = value?.cost_center?.name;
      userData.value.cargo = value?.roles[0]?.name;
      userData.value.matricula = value?.sap;
      unidadeList.value = value?.vendors;
    };

    const getUnidade = () => {
      quasar.loading.show();
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
        getDados();
      }
    };

    onMounted(getUnidade);

    const getTitleColor = (tipo) => {
      switch (tipo) {
        case "Nunca retirou":
          return "#8A8A8A";

        case "ATRASADO":
          return "#dd2153";

        case "OK":
          return "#85D546";

        case "ATENÇÃO":
          return "#D19600";

        default:
      }
    };

    watch(
      () => grupo.value,
      () => {
        getDados();
      }
    );

    watch(
      () => status.value,
      () => {
        getDados();
      }
    );

    watch(
      () => userData.value.nome,
      () => {
        getDados();
      }
    );

    watch(
      () => unidade.value.id,
      () => {
        getDados();
      }
    );
    watch(
      () => pagination.value.page,
      () => {
        getDados();
      }
    );

    return {
      backPage,
      unidade,
      receberFuncionario,
      userData,
      unidadeList,
      dadosTopo,
      rows,
      time,
      getTitleColor,
      status,
      grupo,
      getDadosTopo,
      pagination,
      activeSlide,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      tipos: [
        { label: "Todos", value: "" },
        { label: "Dentro do Prazo", value: "bloqueado" },
        { label: "Pode Trocar", value: "liberado" },
        { label: "Deve Trocar", value: "atrasado" },
      ],
      infos: [
        {
          text: "Item nunca retirado pelo usuário.",
          type: "Nunca Retirou",
        },
        {
          text: "Item não atingiu o prazo mínimo da próxima retirada.",
          type: "Ok",
        },
        {
          text: "Item atingiu o prazo mínimo para a retirada, indicando os dias restantes para vencer.",
          type: "Atenção",
        },
        {
          text: "Item excedeu o prazo máximo para a retirada, indicando os dias vencidos.",
          type: "Atrasado",
        },
      ],
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
</style>

<style scoped>
.cards-topo {
  display: flex;
  margin-bottom: 32px;
  gap: 24px;
  margin-top: 20px;
}
.cards-topo section {
  width: 280px;
  height: 101px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.grupo-container {
  display: flex;
  width: 520px;
  height: 117px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
}

.cards-topo .sub {
  background-color: rgba(0, 0, 0, 0.479);
  width: 256px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.info-user {
  padding: 12px;
  height: 150px;
  max-width: 890px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-top: 26px;
}

.texto-titulo-input {
  font-size: 12px;
}

.list-container {
  margin-top: 30px;
  gap: 12px;
}

.align-center {
  align-items: center;
}
</style>
